//点击变体替换价格和样式
let list = document.querySelectorAll(".glamping-booster_variant-list li")
let original_price = document.querySelector(".glamping-booster_variant-price-group #original_price span")
let price = document.querySelector(".glamping-booster_variant-price-group #price span")
let buynow = document.querySelector("#glamping_booster-buynow")
let variant_text = document.querySelector(".glamping-booster_variant-name")
for(let i=0;i<list.length;i++){
  list[i].onclick = function(){
    for(let j = 0;j<list.length;j++){
      list[j].classList.remove('active')
    }
    this.classList.add('active')
    original_price && (original_price.innerHTML = this.getAttribute("original-price"))
    price.innerHTML = this.getAttribute("price")
    buynow.href=this.getAttribute("url")
    variant_text.innerHTML = this.children[1].innerText.replace("\n"," ");
  }
}

//点击最下方的stickyBox替换样式
let stickyBox = document.querySelectorAll(".sticky-box-left a")
let sticky_box_right_1 = document.querySelector("#sticky-box-right-1")
let sticky_box_right_2 = document.querySelector("#sticky-box-right-2")
let sticky_box_right_3 = document.querySelector("#sticky-box-right-3")
for(let i = 0;i<stickyBox.length;i++){
  stickyBox[i].onclick = function(){
    removeStickyBoxActive()
    this.classList.add('active')
  }
}
function removeStickyBoxActive(){
  for(let j = 0;j<stickyBox.length;j++){
      stickyBox[j].classList.remove('active')
    }
}





  //当屏幕宽度小于768时，取消掉某些dom的定位滚动特效，因为此时的高度已经超过了100%,此特效会覆盖掉下面的内容
  removeScrollMaggicDom()
  window.onresize = function(){
    removeScrollMaggicDom()
  }
  function removeScrollMaggicDom(){
    let width = window.screen.width
    if(width <= 768){
      document.querySelector("#glamping-companion_variant-content").classList.remove('scrollMagic')
    }
  }
  
// 监听最下方的stickyBox-right的滚动,让左边的a标签随之高亮
//   window.addEventListener('scroll',function(){
//   let father = document.querySelector(".glamping-companion").offsetTop
//   let top = document.documentElement.scrollTop + father || document.body.scrollTop + father
//   let t1 = sticky_box_right_1.offsetTop + father
//   let t2 = sticky_box_right_2.offsetTop + father
//   let t3 = sticky_box_right_3.offsetTop + father
//   if(top>=t3){
   
//     removeStickyBoxActive()
//     stickyBox[2].classList.add('active')
//   }else if(top>=t2-10 && top<t3){
//     removeStickyBoxActive()
//     stickyBox[1].classList.add('active')
//   }else{
//     removeStickyBoxActive()
//     stickyBox[0].classList.add('active')
//   }
// })
  function showleftStick(index){
    removeStickyBoxActive(index)
    stickyBox[index].classList.add('active')
  }

  var controller = new ScrollMagic.Controller({
  globalSceneOptions: {
    triggerHook: 'onLeave',
    duration: "200%" // this works just fine with duration 0 as well
  }
  });

  // get all slides
  var slides = document.querySelectorAll(".scrollMagic");
  
  // create scene for every slide
  for (var i=0; i<slides.length; i++) {
    new ScrollMagic.Scene({
        triggerElement: slides[i]
      })
      .setPin(slides[i], {pushFollowers: false})
      .addTo(controller);
  }


  // let stickyAll = document.querySelectorAll(".sticky-box-right>div")
  // let sticky1 = document.querySelector("#sticky-box-right-1")
  // let sticky2 = document.querySelector("#sticky-box-right-2")
  // let sticky3 = document.querySelector("#sticky-box-right-3")
  // let showSticky = document.querySelector(".sticky-box-show")
  // sticky1.addEventListener('inview', function () {
  //       handleShowStickyBox(1)
  // });
  // sticky2.addEventListener('inview', function () {
  //       handleShowStickyBox(2)
  //   });
  // sticky3.addEventListener('inview', function () {
  //       handleShowStickyBox(3)
  // });
  // function handleShowStickyBox(index){
  //   showSticky.innerHTML = stickyAll[index].innerHTML
  //   showleftStick(index-1)
  // }
  // var controllerTabs = new ScrollMagic.Controller();

		// // define movement of panels
		// var wipeAnimation = new TimelineMax()
		// 	.fromTo("#sticky-box-right-2", 1, {y: "100%"}, {y: "0%", ease: Linear.easeNone})  // in from left
		// 	.fromTo("#sticky-box-right-3",    1, {y:  "100%"}, {y: "0%", ease: Linear.easeNone})  // in from right

		// // create scene to pin and link animation
		// new ScrollMagic.Scene({
		// 		triggerElement: "#pinContainer",
		// 		triggerHook: "onLeave",
		// 		duration: "300%",
  //               onComplete:function(){
 
  //               }
		// 	})
		// 	.setPin(".sticky-box-right")
		// 	.setTween(wipeAnimation)
		// 	.addTo(controllerTabs);

